import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import { Divider, IconButton, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import CloseIcon from '@mui/icons-material/Close';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import { PlanoPagto } from '../../dto/PlanoPagamento';
import CustomTableSelectPlanoPagamento from '../customTableSelcetPlanoPagamento/customTableSelectPlanoPagamento';
const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '6px',
};

export default function CustomModalSelectPlanoPagamento(props: {
  data: PlanoPagto[],
  buscouPlanoPgto: boolean;
  openModal: boolean,
  isSearch: boolean,
  handleFunction: () => void,
  handleSetPlanoPagamento: (planoPagto: PlanoPagto) => void,
  havePlanoPgto: boolean
}) {
  const [open, setOpen] = React.useState(props.openModal);
  const [searchValue, setSearchValue] = React.useState('');
  const [filteredData, setFilteredData] = React.useState<PlanoPagto[]>([]);

  const handleOpen = () => {
    setOpen(true);
    props.handleFunction();
  };

  const handleClose = () => {
    setOpen(false);
    setSearchValue("");
  }

  const handleSetPlanoPagamento = (planoPagamento: PlanoPagto) => {
    props.handleSetPlanoPagamento(planoPagamento);
    handleClose();
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.toLowerCase();
    setSearchValue(value);

    const filtered = props.data.filter((agente) =>
      Object.values(agente).some((val) =>
        val?.toString().toLowerCase().includes(value)
      )
    );
    setFilteredData(filtered);
  };

  React.useEffect(() => {
    if (open) {
      setFilteredData(props.data);
    }
  }, [open, props.data]);

  const inputRef = React.useRef<HTMLInputElement | null>(null);

  React.useEffect(() => {
    if (open) {
      // pequeno delay para garantir que o conteúdo já foi montado
      setTimeout(() => {
        inputRef.current?.focus();
      }, 0);
    }
  }, [open]);

  return (
    <div>
      {!props.isSearch && (
        <Button
          className="fields"
          variant="contained"
          onClick={handleOpen}
          sx={{ maxWidth: 200, backgroundColor: '#5693B9', color: '#fff', fontWeight: 'bold', marginTop: 2, marginLeft: 2 }}
          disabled={props.havePlanoPgto}
        >
          Forma Cob
        </Button>
      )}
      {props.isSearch && (
        <IconButton
          aria-label="search"
          sx={{ color: '#0965c1', padding: 0 }}
          onClick={handleOpen}
          disabled={props.havePlanoPgto}
        >
          {!props.havePlanoPgto ? <SearchIcon /> : <SearchOffIcon />}
        </IconButton>
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            ...style,
            position: 'relative',
            p: 3,
            height: '70vh',
            width: '60%',
            maxWidth: '1100px',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 0,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <MonetizationOnRoundedIcon sx={{ fontSize: 20, color: '#0965c1' }} />
              <Typography id="modal-modal-title" marginBottom={-0.2} variant="subtitle1" align='center' component="h2" fontSize='15px' color='#334155'>
                Buscar Plano Pagamento
              </Typography>
            </Box>

            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                color: '#5693B9',
                '&:hover': {
                  color: 'gray',
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider sx={{ width: '100%', marginBottom: 2, marginTop: -0.4 }} />
          <TextField
            fullWidth
            label=""
            variant="outlined"
            value={searchValue}
            onChange={handleSearchChange}
            autoFocus
            inputRef={inputRef}
            sx={{ marginBottom: 2 }}
            size="small"
          />
          <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
            <CustomTableSelectPlanoPagamento data={filteredData} buscouPlanoPgto={props.buscouPlanoPgto} handleSetPlanoPagamento={handleSetPlanoPagamento} />
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
